import { render, staticRenderFns } from "./Controller.vue?vue&type=template&id=60e2b752"
import script from "./Controller.vue?vue&type=script&lang=ts"
export * from "./Controller.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports